import { FormGroup, Switch } from "@mui/material";
import { styled } from '@mui/material/styles';
import { Stack } from "react-bootstrap";




const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#2C633C' : '#2C633C',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
  }));


  export default function SwitchButton({
    onToggle =(value) => {},
    defaultValue = true
  }) {
    return (
      <FormGroup>
        <Stack direction="row" spacing={1} alignItems="center">
          <AntSwitch checked={defaultValue} onChange={onToggle} defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
        </Stack>
      </FormGroup>
    );
  }